import Vue from 'vue'
import App from './App.vue'

import router from './router'	//引入路由模块

import axios from 'axios'	//引入Axios模块
import VueAxios from 'vue-axios'

import ElementUI from 'element-ui';		//引入Element-UI模块
import 'element-ui/lib/theme-chalk/index.css';

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'E4vYNbh4LBcHlmzE9dmE5KVv2NMxvFBY',
  // 设置 BMapURL 为 https 版本的地图
  BMapURL: 'https://api.map.baidu.com/api?v=2.0&s=1&services=false',
});

Vue.use(VueAxios, axios)	//使用Axios模块

Vue.use(ElementUI);		//使用Element-UI模块

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router	//使用路由模块
}).$mount('#app')


